import logo from "../images/MainLogo.svg";
import homeicon from "../images/homeicon.svg";
import swapIcon from "../images/swapGoldIcon.svg";
import stakeIcon from "../images/stakeIcon.png";
import blogIcon from "../images/blogIcon.png";
import contactIcon from "../images/contactIcon.png";
import helpIcon from "../images/helpIcon.png";
import { NavLink } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { useNavbar } from "../providers/navbar";

const Navbar = () => {
  const { navbarIsOpen, closeNavbar } = useNavbar();

  return (
    <nav
      className={`
        bg-black/80 top-0 border border-yellow-400 p-5 min-h-screen fixed left-0 z-30 
        rounded-r-3xl w-[200px]
        transform transition-transform duration-500 ease-in-out
        ${navbarIsOpen ? "translate-x-0" : "-translate-x-full"}
      `}
    >
      <div className="flex flex-col justify-between pb-12 h-screen">
        <div>
          <div className="flex justify-end mb-3">
            <button onClick={closeNavbar}>
              <FaTimes />
            </button>
          </div>
          <img src={logo} className="w-[230px]" alt="Swiss Gold" />

          <NavLink
            to={"/"}
            onClick={closeNavbar}
            className={({ isActive }) =>
              `px-2 py-2 mt-5 flex items-center rounded-md text-sm font-medium ${
                isActive
                  ? "text-yellow-400"
                  : "text-gray-300 hover:text-white"
              }`
            }
          >
            <img className="mx-2" src={homeicon} alt="Home"/> Home
          </NavLink>

          <NavLink
            to={"/swapgold"}
            onClick={closeNavbar}
            className={({ isActive }) =>
              `px-2 py-2 flex items-center rounded-md text-sm font-medium ${
                isActive
                  ? "text-yellow-400"
                  : "text-gray-300 hover:text-white"
              }`
            }
          >
            <img className="mx-2" src={swapIcon} alt="Swap Gold"/> Swap Gold
          </NavLink>

          <NavLink
            to={"/stake"}
            onClick={closeNavbar}
            className={({ isActive }) =>
              `px-2 py-2 flex items-center rounded-md text-sm font-medium ${
                isActive
                  ? "text-yellow-400"
                  : "text-gray-300 hover:text-white"
              }`
            }
          >
            <img className="mx-2" src={stakeIcon} alt="Stake"/> Stake
          </NavLink>

          <NavLink
            to={"/blog"}
            onClick={closeNavbar}
            className={({ isActive }) =>
              `px-2 py-2 flex items-center rounded-md text-sm font-medium ${
                isActive
                  ? "text-yellow-400"
                  : "text-gray-300 hover:text-white"
              }`
            }
          >
            <img className="mx-2" src={blogIcon} alt="Blog"/> Blog
          </NavLink>

          <NavLink
            to={"/contact"}
            onClick={closeNavbar}
            className={({ isActive }) =>
              `px-2 py-2 flex items-center rounded-md text-sm font-medium ${
                isActive
                  ? "text-yellow-400"
                  : "text-gray-300 hover:text-white"
              }`
            }
          >
            <img className="mx-2" src={contactIcon} alt="Contact"/> Contact
          </NavLink>
        </div>

        <div className="h-full flex justify-end flex-col">
          <NavLink
            to={"/contact"}
            onClick={closeNavbar}
            className={({ isActive }) =>
              `px-2 py-2 flex items-center rounded-md text-sm font-medium ${
                isActive
                  ? "text-yellow-400"
                  : "text-gray-300 hover:text-white"
              }`
            }
          >
            <img className="mx-2" src={helpIcon} alt="Help Center"/> Help Center
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
